import { Paper, Typography } from "@mui/material";

export default function NotAuthorized(): JSX.Element {
	return (
		<Paper sx={{ p: 4, textAlign: "center" }}>
			<Typography variant="h6" sx={{ mb: 1 }}>
				Acesso restrito
			</Typography>
			<Typography variant="body2" color="text.secondary">
				Esta tela é exclusiva para administradores de sistema.
			</Typography>
		</Paper>
	);
}
